module.exports = __webpack_public_path__ + "static/media/SpaceX-Logo.be1004e8.svg";